import { useInfiniteQuery } from '@tanstack/react-query';

import { listNotifications } from '@/api/notifications';
import { notificationKeys } from './keys';

const PAGE_SIZE = 20;

export function useNotificationList(unreadOnly = false, enabled = true) {
  return useInfiniteQuery({
    queryKey: notificationKeys.list(unreadOnly),
    queryFn: ({ pageParam }) =>
      listNotifications({ cursor: pageParam, limit: PAGE_SIZE, unreadOnly }),
    initialPageParam: '',
    getNextPageParam: (last) => last.next_cursor || undefined,
    enabled,
  });
}
